import filter from 'lodash/filter';
import { connect } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { css } from 'react-emotion';
import { withRouter } from 'react-router';
import yup from 'yup';

import { ProjectActions } from '../../../actions/project';
import Loading from '../../../components/Loading';
import InputField, { sideError } from './InputField';
import ImportFileInput from './ImportFileInput';

const test = css({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 350,
});

const organizationPlansQuery = gql`
  query organizationPlans($organizationId: ID!) {
    organizationPlans(organizationId: $organizationId) {
      plan {
        id
        name
      }
      quantityAvailable
    }
  }
`;

const withData = graphql(organizationPlansQuery, {
  options: ({ params, organizationId }) => ({
    variables: {
      organizationId,
    },
    fetchPolicy: 'network-only',
  }),
});

@connect()
@withRouter
@withData
export default class ImportProjectForm extends PureComponent {
  static propTypes = {
    onSuccess: PropTypes.func.isRequired,
    reset: PropTypes.func,
    handleSubmit: PropTypes.func,
    submitting: PropTypes.func,
    error: PropTypes.func,
    data: PropTypes.object,
    accountId: PropTypes.string.isRequired,
  };

  submit = async (values) => {
    console.log(values);
    const { accountId, dispatch, onSuccess } = this.props;
    // console.log('values', values);
    const newProject = {
      name: values.projectName,
      description: values.projectDescription,
      file: values.file,
      accountId: accountId,
      planId: values.planId,
    };

    const action = ProjectActions.importJSONProject(newProject);

    await dispatch(action);
    if (onSuccess) onSuccess();
  };

  render() {
    const {
      data: { organizationPlans, loading },
      params: { accountId },
    } = this.props;

    if (loading) return <Loading />;

    const availablePlans = filter(organizationPlans, p => {
      return p.quantityAvailable > 0;
    });

    const initialValues = {
      projectName: '',
      projectDescription: '',
      projectIndustry: 1,
      accountId,
      planId: '',
    };

    const validation = yup.object().shape({
      projectName: yup.string().required('Please enter project name'),
      // projectDescription: yup.string().required('Please specify project description'),
      planId: yup.string().required('No purchased plans available.'),
      file: yup.string().required('Please specify import file.'),
    });

    if(availablePlans.length) {
      initialValues.planId = availablePlans[0].plan.id;
    }

    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validation}
        onSubmit={this.submit}
        render={({ errors, touched, setFieldValue, isSubmitting }) => (
          <Form className={test}>
            <Field
              name="file"
              component={ImportFileInput}
              label="Import File"
              type="file"
              className="form-control-file"
            />
            <Field
              name="projectName"
              component={InputField}
              label="Project Name"
              placeholder="Name your project"
            />
            <Field
              name="projectDescription"
              component={InputField}
              label="Project Description"
              placeholder="Enter a description for your project"
              type="textarea"
            />
            <div style={{ marginBottom: 16 }}>
              <label htmlFor="planId">Plan</label>
              <Field
                name="planId"
                component="select"
                className="form-control"
              >
                {availablePlans.map(p => (
                  <option key={p.plan.id} value={p.plan.id}>
                    {p.plan.name}
                  </option>
                ))}
              </Field>
              {touched.planId &&
                errors.planId && (
                  <div className={sideError}>{errors.planId}</div>
                )}
            </div>
            <div className="form-group row justify-content-end">
              <button
                className="btn btn-primary modal-button-full"
                type="submit"
                disabled={isSubmitting}
              >
                {!isSubmitting && 'Create Project'}
                {isSubmitting && (
                  <span>
                    <i className="fa fa-spinner fa-pulse fa-fw" /> Creating
                    Project...
                  </span>
                )}
              </button>
            </div>
          </Form>
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/NewProjectButtons/ImportProjectForm.js